
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 3.028a3 3 0 013-3h12a3 3 0 013 3v9a3 3 0 01-3 3h-4.141l-3.155 2.599c-.979.806-2.454.11-2.454-1.158v-1.44H3a3 3 0 01-3-3v-9zm3-1a1 1 0 00-1 1v9a1 1 0 001 1h4.25v2.381l2.891-2.38H15a1 1 0 001-1v-9a1 1 0 00-1-1H3z","fill":"#191F2D"}}),_c('path',{attrs:{"d":"M12.322 7.863c.51.18.785.746.5 1.205a4.5 4.5 0 01-7.59.086c-.295-.452-.032-1.025.474-1.216.505-.191 1.06.084 1.426.48a2.543 2.543 0 003.775-.042c.357-.405.905-.693 1.415-.513zM8 5.692a1 1 0 11-2 0 1 1 0 012 0zM12 5.692a1 1 0 11-2 0 1 1 0 012 0z","fill":"#191F2D"}})])
          )
        }
      }
    